var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 1.75C2.30964 1.75 1.75 2.30964 1.75 3V14.75C1.75 15.4404 2.30964 16 3 16H11.2538C11.9443 16 12.504 15.4401 12.5038 14.7495C12.5038 14.7495 12.5038 14.7495 12.5038 14.7495L12.5004 6.78659C12.5002 6.45528 12.3686 6.13753 12.1343 5.90326L8.34714 2.11612C8.11273 1.8817 7.79478 1.75 7.46326 1.75H3ZM0.25 3C0.25 1.48122 1.48122 0.25 3 0.25H7.46326C8.1926 0.25 8.89208 0.539723 9.4078 1.05546M9.4078 1.05546L13.1949 4.84254C13.1949 4.84255 13.1949 4.84253 13.1949 4.84254C13.7103 5.35797 14.0001 6.05701 14.0004 6.78595C14.0004 6.78596 14.0004 6.78594 14.0004 6.78595L14.0038 14.7489C14.0043 16.2681 12.773 17.5 11.2538 17.5H3C1.48123 17.5 0.25 16.2688 0.25 14.75V3",
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/report.8c08d132ac2554e6bbdace0f7b513585.svg";
export { ForwardRef as ReactComponent };